var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useRef, useEffect } from 'react';
import { useFormLayout } from '../../form-layout';
export function useOverflow() {
    var _a = __read(useState(false), 2), overflow = _a[0], setOverflow = _a[1];
    var containerRef = useRef(null);
    var contentRef = useRef(null);
    var layout = useFormLayout();
    var labelCol = JSON.stringify(layout.labelCol);
    useEffect(function () {
        requestAnimationFrame(function () {
            if (containerRef.current && contentRef.current) {
                var contentWidth = contentRef.current.getBoundingClientRect().width;
                var containerWidth = containerRef.current.getBoundingClientRect().width;
                if (contentWidth && containerWidth && containerWidth < contentWidth) {
                    if (!overflow)
                        setOverflow(true);
                }
                else {
                    if (overflow)
                        setOverflow(false);
                }
            }
        });
    }, [labelCol]);
    return {
        overflow: overflow,
        containerRef: containerRef,
        contentRef: contentRef,
    };
}
//# sourceMappingURL=useOverflow.js.map